import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useLiveRef, useUniqueEffect } from '../../hooks';
import { usePrerequisites } from '.';

export const getSearchParams = () => {
	const startIndex = window.location.href.indexOf('?');
	const searchStr = startIndex >= 0 ? window.location.href.substring(startIndex + 1) : null;
	return new URLSearchParams(...(searchStr ? [searchStr] : []));
};

const RoutesGuard = ({ redirectTo = '/login' }) => {
	const { loggedin, license } = useSelector((state) => state?.auth || {});
	const navigate = useNavigate();
	const [{ ready, inSetup }] = usePrerequisites();
	const [searchParams] = useSearchParams();
	const locationRef = useLiveRef(useLocation());
	const pathname = locationRef.current.pathname;
	const searchParamsRef = useLiveRef(searchParams);
	const baseRouteRef = useLiveRef(license.baseRoute);
	const loggedinRef = useLiveRef(loggedin);
	const isOnPublicRoute = ['/', '/login', '/forgotpassword'].includes(locationRef.current.pathname?.toLowerCase());
	const isSetupRoute = ['/setup'].includes(locationRef.current.pathname?.toLowerCase());
	const getInitialRoute = useCallback(() => {
		const isLogout = searchParamsRef.current.has('isLogout');
		let redirectToPath;
		if (loggedinRef.current) {
			redirectToPath = searchParamsRef.current.has('tonavigate')? searchParamsRef.current.get('tonavigate') : isOnPublicRoute? baseRouteRef.current : locationRef.current.path;
		} else if (!isOnPublicRoute && !isLogout && !isSetupRoute && loggedin) {
			redirectToPath = `${redirectTo}?tonavigate=${encodeURIComponent(
				`${locationRef.current.pathname}${locationRef.current.search}`
			)}`;
			}
			else if (isOnPublicRoute && locationRef.current.pathname !== '/') {
			redirectToPath = locationRef.current.pathname;
		} else {
			redirectToPath = '/login';
		}
		return redirectToPath;
	}, [isOnPublicRoute, loggedin])
	useUniqueEffect(() => {
		if (ready) {
			if (!inSetup) {
				const redirectToPath = getInitialRoute();
				if (typeof redirectToPath === 'string' && redirectToPath?.toLowerCase() !== locationRef.current.pathname?.toLowerCase()) {
					navigate(redirectToPath);
				}
			}
			else if(pathname.toLowerCase() !== '/setup') {
				navigate('/setup');
			}
		}
	}, [loggedin, ready, inSetup]);

	useUniqueEffect(() => {
		if (loggedinRef.current && isOnPublicRoute && !inSetup) {
			const redirectToPath = getInitialRoute();
			navigate(redirectToPath);
		}
	}, [isOnPublicRoute]);

};

export default memo(RoutesGuard);